export default "__VITE_ASSET__BKVJPerZ__"